import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import React, { useCallback, useLayoutEffect, useMemo } from 'react';
import { Accordion } from '../accordion/accordion';
import styles from './accordion-group.module.scss';
const AccordionGroup = ({ alignIconRight = false, autoClose = false, border = false, children, expanded = false, iconColor, iconType = 'chevron', titleColor = '#000', titles = [], isTitleBold = false, disableCollapse = false, focusable = true, icons, disableIcon = false, disableARIA, size = 'sm', fullWidth = false, colorizeHeader = false, headerHeight = 40, }) => {
    const [items, setItems] = React.useState(Array.isArray(children)
        ? children.map(() => ({
            expanded: expanded,
            id: nanoid(),
        }))
        : []);
    const handleExpand = useCallback((id) => {
        setItems(prev => prev.map(item => ({
            ...item,
            expanded: autoClose ? item.id === id : item.id === id || item.expanded,
        })));
    }, []);
    const handleCollapse = useCallback((id) => {
        setItems(prev => prev.map(item => ({
            ...item,
            expanded: autoClose ? false : item.id === id ? false : item.expanded,
        })));
    }, []);
    const groupClass = useMemo(() => {
        return classNames(styles.group, {
            [styles.grp_no_border]: !border,
        });
    }, []);
    useLayoutEffect(() => {
        if (titles.length) {
            setItems(() => titles.map(() => ({
                expanded: expanded,
                id: nanoid(),
            })));
        }
        else {
            setItems([]);
        }
    }, [titles.length]);
    return (_jsx("div", { className: groupClass, children: items.map((item, index) => (_jsx("div", { className: styles.group_item, role: !disableARIA ? 'group' : '', children: _jsx(Accordion, { id: item.id, onExpanded: handleExpand, onCollapsed: handleCollapse, title: titles[index], expanded: item.expanded, alignIconRight: alignIconRight, iconType: iconType, titleColor: titleColor, iconColor: iconColor, isTitleBold: isTitleBold, disableCollapse: disableCollapse, disableIcon: disableIcon, focusable: focusable, customIcon: icons && icons[index], disableARIA: disableARIA, size: size, fullWidth: fullWidth, colorizeHeader: colorizeHeader, headerHeight: headerHeight, children: children && children[index] }) }, item.id))) }));
};
AccordionGroup.displayName = 'AccordionGroup';
export { AccordionGroup };
